/**
 * Company: SPHMedia
 * Description: [NDR Banner]
 */

import NDRDesktopIcon from "@assets/ndr2025/SG60-primary-logo-desktop.png";
import NDRMobileIcon from "@assets/ndr2025/SG60-primary-logo-mobile.png";
import { NDR_2025_PAGE } from "@config/ndr2025";
import Link from "@elements/Typography/Link";
import { ReactElement } from "react";

/**
 * GEBanner
 * Description: [NDR Banner component]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function NDRBanner(): ReactElement {
  const landingPagePath = `${NDR_2025_PAGE}?ref=banner`;

  return (
    <div className="flex justify-center items-center bg-gradient-to-r from-blue-950 to-red-450 py-2">
      <div className="gap-2 items-center hidden lg:flex">
        <img src={NDRDesktopIcon} alt="ge-icon" width={30} height={30} />
        <Link
          destination={landingPagePath}
          className="text-md font-medium text-text-inverse font-primary underline leading-[normal]"
        >
          Dapatkan berita terkini Hari Kebangsaan 2025 di sini
        </Link>
      </div>
      <div className="h-[62px] flex lg:hidden gap-2 items-center pl-3">
        <img src={NDRMobileIcon} alt="ge-icon" width={50} height={50} />
        <div className="flex flex-col gap-[2px]">
          <Link
            destination={landingPagePath}
            className="text-[14px] font-semimedium text-text-inverse font-primary underline leading-[20px]"
          >
            Dapatkan berita terkini Hari
            <br />
            Kebangsaan 2025 di sini
          </Link>
        </div>
      </div>
    </div>
  );
}
